import generalUpload from "../_section/upload.class";
import dayjs from "dayjs";

export class userPayslipUpload extends generalUpload {
    constructor(request, upload, queries) {
        super(request, upload, queries);
    }
}
const template= {
    items: [
        {
            name: 'documentDate',
            label: 'Payslip Date',
            type: 'date',
        }, {
            name: 'grossBasic',
            label: 'Gross Basic',
            type: 'currency',
            optional: true

        }, {
            name: 'netPay',
            label: 'Net Pay',
            type: 'currency',
            optional: true
        }, {
            name: 'grossPay',
            label: 'Gross Pay',
            type: 'currency',
            optional: true
        }, {
            name: 'pensionDeduction',
            label: 'Pension Deduct',
            type: 'currency',
            optional: true,
        }, {
            name: 'avcDeduction',
            label: 'AVC Deduct',
            type: 'currency',
            optional: true,
        },
        {
            name: 'shareSave',
            label: 'Share Save',
            type: 'currency',
            optional: true,
        },
        {
            name: 'bik',
            label: 'Benefit in Kind',
            type: 'currency',
            optional: true,
        },
    ]
}
export class adminPayslipUpload extends userPayslipUpload {

    constructor(request, upload, queries, data) {
        super(request, upload, queries);
        const statementAlignmentDate = request?.mortgage?.requirement?.statementAlignmentDate ? dayjs(request.mortgage.requirement.statementAlignmentDate) : null
        const extra =
            (data.usingAvcAmount || 0) +
            (data.usingBikAmount || 0) +
            (data.usingShareSaveAmount || 0)
        this.calcValues(template)
        if (this.values.documentDate) {
            // most recent no older than 4 weeks
            // if no lender - 2 months worth of payslips
            // otherwise haven = 3 payslips, ptsb = 2 payslips, ics = 3 payslips, boi = 2 months worth, nua = 1 month
            // for expiry purposes use worst case scenario - 2 months worth
             // if acv or sharesave, expiry = 7 months, otherwise 4 months

            // const things = data.payFrequency === "MONTHLY"  ?  extra > 0 ? [6,'months'] : [3,'months'] : extra > 0 ? [26, 'weeks'] : [13, 'weeks']
            // const normalExpiry = this.values.documentDate.add(...things)
            // const alignmentExpiry = statementAlignmentDate
            //     ? statementAlignmentDate.subtract(...things)
            //     : null
            const expires = this.values.documentDate.add(extra > 0 ? 8 : 4.5, "months")
            // const expires =
            //     alignmentExpiry && this.values.documentDate.isBefore(alignmentExpiry)
            //         ? statementAlignmentDate
            //         : normalExpiry
            this.setDateData({
                dated: this.values.documentDate,
                expires,
            })
        }
    }
}
